import { IPlatform } from "models";
import createFastContext from "./fastContext";

type PlatformFastContextData = {
  platform: IPlatform | null;
};

export const {
  Provider: PlatformFastContextProvider,
  useStore: usePlatformFastContext,
  useStoreOptional: usePlatformFastContextOptional,
} = createFastContext<PlatformFastContextData>({
  platform: null,
});
